module.exports = __webpack_public_path__ + "img/story-icon.7a2b9b44.svg";